import cutWebm from "../../../../src/video/ngpm-cut.webm";
import cutMp4 from "../../../../src/video/ngpm-cut.mp4";
import cutPoster from "../../../../src/video/ngpm-cut.jpg";
import * as React from 'react';
export default {
  cutWebm,
  cutMp4,
  cutPoster,
  React
};